
export const FooterDescription = () => (
  <p className="text-cool-gray-500 text-xs leading-[18px] font-medium mt-5  pt-3 pb-9 xl:py-9">
    Advance Motors Limited is an Appointed Representative of Automotive
    Compliance Ltd, who is authorized and regulated by the Financial Conduct
    Authority (FCA No 497010). Automotive Compliance Ltd’s permissions as a
    Principal Firm allows Advance Motors Limited to act as a credit broker, not
    as a lender, for the introduction to a limited number of lenders and to act
    as an agent on behalf of the insurer for insurance distribution activities
    only. We can introduce you to a selected panel of lenders, which includes
    Vauxhall Finance. An introduction to a lender does not amount to independent
    financial advice and we act as their agent for this introduction. Our
    approach is to introduce you first to Vauxhall Finance, who are usually able
    to offer the best available package for you, taking into account both
    interest rates and other contributions. If they are unable to make you an
    offer of finance, we then seek to introduce you to whichever of the other
    lenders on our panel is able to be make the next best offer of finance for
    you. Our aim is to secure the best deal you are eligible for from our panel
    of lenders. Lenders may pay a fixed commission to us for introducing you to
    them, calculated by reference to the vehicle model or amount you borrow.
    Different lenders may pay different commissions for such introductions, and
    Vauxhall Finance also provide preferential rates to us for the funding of
    our vehicle stock and also provide financial support for our training and
    marketing. But any such amounts they and other lenders pay us will not
    affect the amounts you pay under your finance agreement, all of which are
    set by the lender concerned. If you ask us what the amount of commission is,
    we will tell you in good time before the Finance agreement is executed. All
    finance applications are subject to status, terms and conditions apply, UK
    residents only, 18’s or over. Guarantees may be required.
  </p>
);
